import { useState } from "react";
import { Switch } from "@mantine/core";
import { RiArrowDownSLine, RiSettings4Line } from "react-icons/ri";
import { switchStyles } from "./memoryFieldStyles";
import css from "./memory.module.scss";

const ROWS = [
  {
    key: "learningEnabled",
    label: "Learn from new conversations and meetings",
    hint: "New facts are saved as we talk and after meetings.",
  },
  {
    key: "recallEnabled",
    label: "Use saved memories",
    hint: "Saved facts are used when I answer you.",
  },
];

const summary = (state) =>
  `Learning ${state.learningEnabled ? "on" : "off"}, recall ${
    state.recallEnabled ? "on" : "off"
  }`;

// Closed by default so the list starts near the top. The summary keeps both
// switch states visible while the section is closed.
export default function MemorySettings({ state, busy, onChange }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={css.shell}>
      <div className={css.core}>
        <button
          type="button"
          className={css.settingsToggle}
          aria-expanded={open}
          aria-controls="memory-settings"
          onClick={() => setOpen((value) => !value)}
        >
          <RiSettings4Line className={css.settingsIcon} aria-hidden="true" />
          <span className={css.settingsTitle}>Memory settings</span>
          <span className={css.settingsSummary}>{summary(state)}</span>
          <RiArrowDownSLine
            className={`${css.settingsChevron} ${open ? css.settingsChevronOpen : ""}`}
            aria-hidden="true"
          />
        </button>
        {open && (
          <div id="memory-settings" className={css.settingsBody}>
            {ROWS.map((row) => (
              <div key={row.key} className={css.settingRow}>
                <Switch
                  styles={switchStyles}
                  labelPosition="left"
                  label={row.label}
                  description={row.hint}
                  checked={state[row.key]}
                  disabled={Boolean(busy) || state.clearing}
                  onChange={(event) =>
                    onChange(row.key, event.currentTarget.checked)
                  }
                />
              </div>
            ))}
          </div>
        )}
        {busy.endsWith("Enabled") && (
          <p className={css.settingBusy} role="status">
            Updating memory settings…
          </p>
        )}
      </div>
    </div>
  );
}
